import { render } from "./BaseRangeDatePicker.vue?vue&type=template&id=0b0b0151"
import script from "./BaseRangeDatePicker.vue?vue&type=script&lang=js"
export * from "./BaseRangeDatePicker.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__